// extracted by mini-css-extract-plugin
export default {"loadingGroup":"loadingGroup--S4daQ","switch":"switch--nuHfb"};